import withIsVisibleHOC from "@client/hocs/withIsVisible";
import User from "@client/widgets/User/container";

export default withIsVisibleHOC(User);
